import { Component, inject } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { DxDropDownButtonModule } from 'devextreme-angular';
import { LANGUAGE_ITEMS } from 'src/app/shared/constants';
import { LocalStorageService } from 'src/app/shared/services/localStorage.service';
import { LanguageObject } from 'src/app/types/languageObject';
import config from '../../../../assets/config.json';

@Component({
    selector: 'app-language-switcher',
    imports: [DxDropDownButtonModule, TranslocoPipe],
    templateUrl: './language-switcher.component.html',
    styleUrl: './language-switcher.component.scss',
})
export class LanguageSwitcherComponent {
    options: LanguageObject[] = LANGUAGE_ITEMS;
    selected: LanguageObject;
    fallbackLocale: string = config.i18n.fallbackLanguage;
    private localStorageService = inject(LocalStorageService);
    private translocoService = inject(TranslocoService);
    displayOption: string;

    constructor() {
        const locale = this.localStorageService.getLocale();
        this.selected = this.options.find(opt => opt.locale === locale);
    }

    formatOption = (item: LanguageObject) =>
        item ? `${item.emoji} ${this.translocoService.translate(item.country)} (${this.translocoService.translate(item.languageCode)})` : '';

    selectLang(e: { item: LanguageObject }): void {
        localStorage.setItem('locale', e.item.locale);
        window.location.reload();
    }
}
